import { Collapsible as Root } from "./collapsible";
import { CollapsibleIndicator } from "./collapsible-indicator";
import { useCollapsible } from "./useCollapsible";

const Collapsible = Root as typeof Root & {
    Indicator: typeof CollapsibleIndicator;
};

Collapsible.Indicator = CollapsibleIndicator;

export { Collapsible, useCollapsible };
